export default {"src":"/_next/static/media/checkbox-mixed.32242cb6.svg","height":20,"width":20};